function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxRound248 = function SvgCheckboxRound248(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "m19.3 24.1 3.3 3.3L29 21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 24.2,
    r: 11.8,
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    }
  }));
};
export default SvgCheckboxRound248;